import { Route } from 'react-router-dom'
import { Routes } from '../Routes'
import { UserKaraokeShow } from 'containers'

export const KaraokeRouter = () => {
  return (
    <Routes>
      <Route path=":slug/*" element={<UserKaraokeShow />} />
    </Routes>
  )
}

export const GuestKaraokeRouter = () => {
  return (
    <Routes>
      <Route path=":slug/*" element={<UserKaraokeShow />} />
    </Routes>
  )
}
